module.exports = __webpack_public_path__ + "img/star.5af02983.svg";